<div class="ui container" appMargin appPadding paddingB="30">
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>

  <div class="ui vertical basic segment">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        class="link"
      >
        <div class="equipment-id">
          <!-- Title -->
          <span class="sub-item">Home </span>
          <h2 class="ui primary header">Foreign Account Detalls</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px"></div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
  </div>

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="30px">
      <div fxFlex="grow">
        <div [innerHtml]="foreignDetails"></div>
      </div>

      <div fxFlex="30%" fxFlex.lt-sm="100%">
        <div [innerHtml]="sidebar"></div>
      </div>
    </div>
  </div>
</div>
